import { tagAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tagAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    backdropFilter: "auto",
    backdropBlur: "4px",
    backgroundColor: "transparent",
    borderStyle: "solid",
    color: "white",
  },
  label: {
    textAlign: "center",
    width: "full",
  },
});

const primaryStyle = definePartsStyle(({ colorScheme }) => ({
  container: {
    backgroundColor: "#5B5F6188",
    borderRadius: "7px",
    backdropFilter: "none",
    textAlign: "start",
    width: "full",
  },
}));

const tagTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    primary: primaryStyle,
  },
});

export default tagTheme;
